<template>
  <div>
    <ts-loading-banner :loading="loading">
      <!-- Homework Section -->
      <div class="section-legend mb-3">
        <h5 class="legend-title">
          <i class="fas fa-book"></i> {{ $t('studentScoringEntry.homeWork') }}
        </h5>
      </div>
      <div class="row">
        <div class="col-md-12 ts-flex">
          <div class="col-md-6">
            <label>{{ $t('studentScoringEntry.assigned') }}</label>
            <div>
              <input v-model="model.assigned" class="form-control" />
            </div>
          </div>
          <div class="col-md-6">
            <label>{{ $t('studentScoringEntry.completed') }}</label>
            <div>
              <input v-model="model.completed" class="form-control" />
            </div>
          </div>
        </div>
      </div>

      <!-- Attendance Section -->
      <div class="section-legend mb-3 mt-4">
        <h5 class="legend-title">
          <i class="fas fa-user-check"></i>
          {{ $t('studentScoringEntry.attendance') }}
        </h5>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 ts-flex">
          <div class="col-md-6">
            <label>{{ $t('studentScoringEntry.present') }}</label>
            <div>
              <input v-model="model.present" class="form-control" />
            </div>
          </div>
          <div class="col-md-6">
            <label>{{ $t('studentScoringEntry.absent') }}</label>
            <div>
              <input v-model="model.absent" class="form-control" />
            </div>
          </div>
        </div>
      </div>

      <!-- Action buttons (commented out as in original) -->
      <div class="row mt-3">
        <div class="col-md-12 text-right">
          <ts-button @click.prevent="$emit('closeModal')">
            {{ $t('cancel') }}
          </ts-button>

          <ts-button
            v-if="model.id == 0"
            class="ml-2"
            color="primary"
            @click.prevent="ratingScaleSave"
            :waiting="save_rating_scale"
          >
            {{ $t('save') }}
          </ts-button>
          <ts-button
            v-if="model.id != 0"
            color="primary"
            :waiting="waiting"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'rating-scale',
  props: ['value'],
  data() {
    return {
      model: {
        assigned: null,
        completed: null,
        absent: null,
        present: null,
        student_id: null,
        id: 0,
        cycle_value: null
      },
      errors: new Errors(),
      save_rating_scale: false,
      waiting: false,
      loading:false
    }
  },
  created() {
    this.model.student_id = this.value.student_id
    this.model.cycle_value = this.value.cycle_value
    this.fetchRatingScal()
  },
  methods: {
    ratingScaleSave() {
      this.errors = new Errors()
      this.save_rating_scale = true
      this.$store
        .dispatch('studentScoringEntry/saveRatingScale', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.save_rating_scale = false
          this.clearForm()
          this.$emit('closeModal')
        })
        .catch(error => {
          this.save_rating_scale = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    fetchRatingScal() {
      this.loading = true
      this.$store
        .dispatch('studentScoringEntry/findRatingScal', {
          params: {
            student_id: this.value.student_id,
            id: this.value.id,
            cycle_value: this.value.cycle_value
          }
        })
        .then(response => {
          if (response.data) {
            this.model.assigned = response.data.assigned
            this.model.completed = response.data.completed
            this.model.absent = response.data.absent
            this.model.present = response.data.present
            this.model.id = response.data.id,
            this.model.cycle_value = response.data.cycle_value
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('studentScoringEntry/updateRatingScale', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearForm()
          this.$emit('closeModal')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearForm() {
      this.model = {
        assigned: null,
        completed: null,
        absent: null,
        present: null,
        student_id: null
      }
    }
  }
}
</script>

<style scoped>
.section-legend {
  border-left: 4px solid #007bff;
  padding-left: 15px;
}

.legend-title {
  color: #6c757d;
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 1rem;
}

.legend-title i {
  margin-right: 8px;
  color: #007bff;
}

.text-muted {
  font-style: italic;
}
</style>
